var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeskAdjustable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 124,
    viewBox: "0 0 132 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 47.5V49L12.5 71V69.5L51.5 47.5Z",
    fill: "#2C2721"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 46L51.5 47.5L12.5 69.5L8 68L48.5 46Z",
    fill: "#4B4E57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 69V68L12.5 69.5V71L8 69Z",
    fill: "#6F6E7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 12L29 14.7345V59.3528L33.5 56.7458V12Z",
    fill: "#2C2721"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59V15.5L27.5 16.5V58.5L29 59Z",
    fill: "#574F3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6273 75.7246L131.194 52.3142L40.5949 0L0 23.4104L90.6273 75.7246Z",
    fill: "#EED8B3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.627 75.7249L131.194 52.3145V53.8639L90.627 77.3024V75.7249Z",
    fill: "#D3A470"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6273 75.7244L0 23.4102V24.9877L90.6273 77.302V75.7244Z",
    fill: "#DFB27B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6273 78.8519L0 26.5377V24.9883L90.6273 77.3025V78.8519Z",
    fill: "#574F3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 79V77L131 53.5V55L90.5 79Z",
    fill: "#2C2721"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 100V101.5L92.5 123.5V122L131.5 100Z",
    fill: "#2C2721"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 98.5L131.5 100L92.5 122L88 120.5L128.5 98.5Z",
    fill: "#4B4E57"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88 121.5V120.5L92.5 122V123.5L88 121.5Z",
    fill: "#6F6E7B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.5 64.5L109 67.2345V111.853L113.5 109.246V64.5Z",
    fill: "#2C2721"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109 111.5V68L107.5 69V111L109 111.5Z",
    fill: "#574F3A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73 72.125V68L90 77.625L85.92 79L73 72.125Z",
    fill: "#2C2D32"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 72,
    r: 1,
    fill: "#A3A3A3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 74,
    r: 1,
    fill: "#A3A3A3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 76,
    r: 1,
    fill: "#A3A3A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskAdjustable);
export default __webpack_public_path__ + "static/media/DeskAdjustable.10b79e5fd0fa15c84abe2e87eac6135a.svg";
export { ForwardRef as ReactComponent };